"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Context = require("../../Context");
var _appconfig = require("../../../selectors/appconfig");
var Styled = _interopRequireWildcard(require("../styles/mds"));
var _MenuGroup = _interopRequireDefault(require("../../Menu/MenuGroup"));
var _utils = require("../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const WithSitemapWrapper = ({
  children,
  history,
  sitemapItems,
  itemNodeRef
}) => {
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [position, setPosition] = (0, _react.useState)({});
  const menuBodyRef = (0, _react.useRef)(null);
  const appconfig = (0, _Context.useSelector)(_appconfig.getAppconfig);
  (0, _react.useLayoutEffect)(() => {
    const pos = (0, _utils.getPosition)(itemNodeRef.current);
    setPosition(pos);
  }, [isOpen, itemNodeRef]);
  const showMenu = () => {
    setIsOpen(true);
  };
  const hideMenu = () => {
    setTimeout(() => setIsOpen(false));
  };
  const constructMenu = (nodes, level = 2) => {
    return nodes.map(node => {
      return _react.default.createElement(_MenuGroup.default, {
        key: node.id,
        node: node,
        level: level,
        isActive: false,
        isExpanded: true,
        history: history,
        sectionsView: level === 2 && (appconfig === null || appconfig === void 0 ? void 0 : appconfig.menuL3AsSection),
        menuRef: menuBodyRef
      }, (ch, lvl) => constructMenu(ch || [], lvl + 1));
    });
  };
  return _react.default.createElement(Styled.SitemapWrapper, {
    onMouseEnter: showMenu,
    onFocus: showMenu,
    onBlur: hideMenu,
    onMouseLeave: hideMenu
  }, children, isOpen && _react.default.createElement(Styled.ClickOutside, {
    onClickOutside: hideMenu
  }, _react.default.createElement(Styled.SitemapDropdownContainer, {
    top: position.bottom,
    left: position.left
  }, (sitemapItems === null || sitemapItems === void 0 ? void 0 : sitemapItems.length) > 0 && constructMenu(sitemapItems))));
};
var _default = exports.default = WithSitemapWrapper;